import moment, { Moment } from "moment";
import { Modify } from "models/helpers";

export interface IEvent {
  _id?: string;
  title: string;
  content: string;
  imageUri: string;
  validFrom?: string;
  expire?: string;
  expiringMinutes?: number;
  isSingleUse?: boolean;
}

interface ConvertedEvent {
  validFrom: Moment;
  expire: Moment;
}

export default class Event implements Modify<IEvent, ConvertedEvent> {
  _id: string;
  title: string;
  content: string;
  imageUri: string;
  validFrom: Moment;
  expire: Moment;
  expiringMinutes: number;
  isSingleUse: boolean;

  constructor(obj: IEvent) {
    Object.assign(this, obj);
    this.validFrom = moment(obj.validFrom);
    this.expire = moment(obj.expire);
  }

  static getCompletionPercentage(start: Moment, end: Moment, now: Moment) {
    const percentage =
      (100 * (now.unix() - start.unix())) / (end.unix() - start.unix());

    return Math.min(Math.max(percentage, 0.01), 100);
  }

  get formattedFrom() {
    return this.validFrom.format("lll");
  }

  get formattedTo() {
    return this.expire.format("lll");
  }
}
